import React, { createContext, useContext, useMemo, useRef } from 'react';

// Para meter un dato ({{nodos.buscar.data.0.nombre}}) en el último campo de plantilla que se usó: cada campo se registra al recibir
// el foco y los paneles de datos llaman `insert`. Si no hay campo activo, el dato se copia al portapapeles.
const Ctx = createContext({ register: () => {}, insert: () => false });

export function InsertProvider({ children }) {
  const last = useRef(null);
  const value = useMemo(() => ({
    register: (fn) => { last.current = fn; },
    insert: (text) => { if (last.current && document.contains(last.current.el)) { last.current.insert(text); return true; } return false; },
  }), []);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useInsert = () => useContext(Ctx);

// Datos con los que se arma la vista previa de las plantillas: { entrada, nodos } de la última prueba, la ejecución abierta o los datos
// fijados. null = todavía no hay datos.
const ScopeCtx = createContext(null);
export const ScopeProvider = ({ scope, children }) => <ScopeCtx.Provider value={scope}>{children}</ScopeCtx.Provider>;
export const useScope = () => useContext(ScopeCtx);
